package com.milta.feature.legal.data.remote.dto

import kotlinx.serialization.Serializable

/** GET /api/v1/legal-documents/{type}?lang={lang} response body. */
@Serializable
data class LegalDocumentDto(
    val title: String,
    val content: String,
    val updatedAt: String,
)
